module.exports = __webpack_public_path__ + "img/login.e60dadcc.png";